import React from "react";
import { FiMapPin, FiExternalLink, FiShoppingBag, FiHeart } from "react-icons/fi";
import Button from "../../ui/Button.jsx";

const StoreCard = ({ store }) => {
    const {
        name,
        description,
        address,
        website,
        category,
        icon: Icon = FiShoppingBag
    } = store;

    return (
        <div className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-pink-100 overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r "></div>

            <div className="p-6 flex flex-col h-full">

            <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-gradient-to-r from-pink-100 to-purple-100 rounded-full">
                            <Icon className="text-pink-600 text-xl" />
                        </div>
                        <div>
                            <h3 className="text-lg font-bold text-gray-800 group-hover:text-pink-600 transition-colors">
                                {name}
                            </h3>
                            <span className="text-xs bg-pink-100 text-pink-700 px-2 py-1 rounded-full font-medium">
                                {category}
                            </span>
                        </div>
                    </div>
                </div>

                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {description}
                </p>


                {website && (
                    <div className="mt-auto">
                        <div className="flex items-center gap-2 text-gray-500 text-sm mb-4">
                            <FiMapPin className="text-pink-400" />
                            <span>{address}</span>
                        </div>

                        <Button
                            size="small"
                            href={website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 shadow-md"
                        >
                            <FiExternalLink className="text-sm" />
                            Visit Website
                        </Button>
                    </div>
                )}

            </div>
        </div>
    );
};

export default StoreCard;